<script>
import SidebarLang from "./components/SidebarLang.vue";
import SidebarAca from "./components/SidebarAca.vue";
export default {
    components: {
        SidebarLang,
        SidebarAca,
    },
    data() {
        return {
            ActiveTab: "",
            isActive: false,
        };
    },
    methods: {
        showSideBar() {
            this.isActive = !this.isActive;
        },
    },
    computed: {
        ag() {
            return this.$parent.ag;
        },
        wid() {
            return this.$parent.wid;
        },
        Setting() {
            return this.$parent.Settings;
        },
        Translation() {
            return this.$parent.Translation;
        },
        SetMascot() {
            if (this.ActiveTab == "academic") {
                if (this.Setting.MascotIdAca) {
                    return "background-image: url(https://studentpanel.net/widget/mascots/mascot-" + this.Setting.MascotIdAca + "-min.svg)";
                } else {
                    return "";
                }
            } else if (this.ActiveTab == "language") {
                if (this.Setting.MascotIdLang) {
                    return "background-image: url(https://studentpanel.net/widget/mascots/mascot-" + this.Setting.MascotIdLang + "-min.svg)";
                } else {
                    return "";
                }
            }
        },
    },
    mounted() {
        if (this.Setting.SearchMode === 0) {
            this.ActiveTab = "language";
        } else if (this.Setting.SearchMode === 1) {
            this.ActiveTab = "language";
        } else if (this.Setting.SearchMode === 2) {
            this.ActiveTab = "academic";
        }

        if (this.Setting.ShowBar) {
            setTimeout(() => {
                this.isActive = true;
            }, 750);
        }
    },
};
</script>
<template>
    <div class="sidebar">
        <button type="button" class="btn btn-trigger" @click="showSideBar">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-mortarboard-fill" viewBox="0 0 16 16" v-if="this.Setting.ShowIcons">
                <path
                    d="M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.275a.5.5 0 0 0 .025-.917l-7.5-3.5Z"
                />
                <path d="M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466 4.176 9.032Z" />
            </svg>
            <span class="btn-trigger-text">
                {{ this.Setting.Title }}
            </span>
        </button>
        <div class="offcanvas offcanvas-end" :class="{show: isActive}" tabindex="-1" id="sideBarCanvas" aria-labelledby="sideBarCanvasLabel">
            <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="sideBarCanvasLabel">
                    <template v-if="ActiveTab === 'language'">
                        {{ this.Setting.LangTitle }}
                    </template>
                    <template v-else-if="ActiveTab === 'academic'">
                        {{ this.Setting.AcaTitle }}
                    </template>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" @click="showSideBar"></button>
            </div>
            <div class="offcanvas-body">
                <div class="switch switch-full" v-if="this.Setting.SearchMode === 0">
                    <button
                        type="button"
                        class="btn border-0 switch-item"
                        v-if="this.Setting.SearchMode === 0 || this.Setting.SearchMode == 1"
                        :class="{active: ActiveTab === 'language'}"
                        @click="ActiveTab = 'language'"
                    >
                        {{ this.Setting.LangSubTitle }}
                    </button>
                    <button
                        type="button"
                        class="btn border-0 switch-item"
                        v-if="this.Setting.SearchMode === 0 || this.Setting.SearchMode == 2"
                        :class="{active: ActiveTab === 'academic'}"
                        @click="ActiveTab = 'academic'"
                    >
                        {{ this.Setting.AcaSubTitle }}
                    </button>
                    <div class="switch-bg"></div>
                </div>
                <SidebarLang v-if="ActiveTab == 'language' && (this.Setting.SearchMode === 0 || this.Setting.SearchMode == 1)" />
                <SidebarAca v-if="ActiveTab == 'academic' && (this.Setting.SearchMode === 0 || this.Setting.SearchMode == 2)" />
            </div>
        </div>
    </div>
</template>
